/** Catalogue limits rendered as centimetres. Explicit units outrank the
 * historical millimetre heuristic retained for older, unitless records. */
export function normalizeCustomSizeLimits(customSizes: {
  minWidth?: unknown; maxWidth?: unknown; minHeight?: unknown; maxHeight?: unknown; sizeUnit?: unknown;
} | null | undefined) {
  const numbers = [customSizes?.minWidth, customSizes?.maxWidth, customSizes?.minHeight, customSizes?.maxHeight]
    .map((value) => Number(value));
  const unit = String(customSizes?.sizeUnit || '').trim().toUpperCase();
  const divisor = unit === 'CM' ? 1 : unit === 'MM' ? 10
    : Math.max(...numbers.map((value) => Number.isFinite(value) ? value : 0)) > 300 ? 10 : 1;
  const values = numbers.map((value) => Number.isFinite(value) && value > 0 ? value / divisor : undefined);
  return { minWidth: values[0], maxWidth: values[1], minHeight: values[2], maxHeight: values[3] };
}
